import React from 'react';
import { IconButton } from '@mui/material';
import { ReactComponent as DocumentIcon } from '@/img/bookings/document.svg';
import { ReactComponent as TrashIcon } from '@/img/bookings/trash.svg';

const FileChip = ({ file, onDelete }) => (
	<div className="bank-transfer__file-chip">
		<DocumentIcon width={20} height={20} />
		<span className="bank-transfer__file-name">{file.name}</span>
		<IconButton size="small" onClick={onDelete}>
			<TrashIcon width={20} height={20} />
		</IconButton>
	</div>
);

export default FileChip;
